module.exports = __webpack_public_path__ + "static/media/intra_oral_left_small.da6a7ba8.png";